import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useFetcher from "@/utils/use-fetcher";
import { ShippingInfo } from "@/features/my-account/types/shipping-info.type";

export interface UpdateShippingInfoRequest {
  alias: string;
  recipientName: string;
  contact: string;
  address: string;
  detailAddress: string;
  zipCode: string;
  isDefault: boolean;
}

interface UpdateShippingInfoResponse extends ShippingInfo {}

export interface UpdateShippingInfoPathParameter {
  companyId: number;
  shippingInfoId: number;
}

export const updateShippingInfoTemplateUrl =
  "/buyers/:companyId/shipping-infos/:shippingInfoId";

export const updateShippingInfoKey: YWRKey<UpdateShippingInfoPathParameter> = {
  url: (parameter) => calcUrl(updateShippingInfoTemplateUrl, parameter),
  method: "put",
};

export default function useUpdateShippingInfo() {
  const fetcher = useFetcher<UpdateShippingInfoRequest, UpdateShippingInfoResponse>();
  return useYWR(updateShippingInfoKey, fetcher);
}
